import React from "react";
import SideBarLeave from "../../Constant/SideBarLeave";
import Footer from "../../Constant/Footer";
import TopBar from "../../Constant/TopBar";
import * as userActions from "../../../actions/index";
import { connect } from "react-redux";
import { useEffect, useState,useRef } from "react";
import { Tooltip } from "@mui/material";
import Pagination from '@mui/material/Pagination';
import { MDBTable, MDBTableHead, MDBTableBody } from 'mdb-react-ui-kit';
import Stack from '@mui/material/Stack';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import IconButton from '@mui/material/IconButton';
import moment from "moment";


const customStyles = {
    // option: (provided, state) => ({
    //     ...provided,
    //     "&:hover": {
    //         backgroundColor: state.isFocused ? "#e7f5fe" : "",
    //     },
    //     backgroundColor: state.isSelected ? "#4a8fb8" : "",
    // }),

     option: (provided, state) => ({
  ...provided,
  "&:hover": {
    backgroundColor:
      !state.isSelected && state.isFocused ? "#e7f5fe" : "",
  },
  backgroundColor: state.isSelected ? "#4a8fb8" : "",
}),
};

const AdhocLeaveHistoryReport = (props) => {
    const [adhocHistoryReport, setAdhocHistoryReport] = useState([])
    const [isCsv, setIsCsv] = useState();
    const [pdf_url, setPdf_url] = useState("")
    const [count, setCount] = useState()


    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [sort, setSort] = useState("");
    const [order, setOrder] = useState("");
    
    const [class_id, setclass_id] = useState("");
    const [dormitory_id, setdormitory_id] = useState("");
    const [class_name, setclass_name] = useState("");
    const [dormitory_name, setdormitory_name] = useState("");

    const [gender, setGender] = useState('');
    const [search, setSearch] = useState("");
    const [to_date, setToDate] = useState("");
    const [from_date, setFromDate] = useState("");
    const [fromTime, setFromTime] = useState("");
    const [toTime, setToTime] = useState("")
   const [showFilters, setShowFilters] = useState(false); // By default filters are hidden
       
          // Add this function to handle the toggle
          const toggleFilters = () => {
             setShowFilters(!showFilters);
          };
    const [dormitory_ids, setdormitory_ids] = useState([]);
    const [class_ids, setclass_ids] = useState([]);
    const row_limit = [
        { value: 5, label: 5 },
        { value: 10, label: 10 },
        { value: 15, label: 15 },
        { value: 20, label: 20 },
        { value: 25, label: 25 },
    ]

    useEffect(() => {
            const delayDebounceFn = setTimeout(() => {
                AdhocHistoryReport();
              }, 500);
          
              return () => clearTimeout(delayDebounceFn);
        },[search])

    useEffect(() => {
        AdhocHistoryReport()
    }, [page, limit, sort, order, class_id, dormitory_id, gender, to_date, from_date,fromTime,toTime])

    const AdhocHistoryReport = (is_pdf = false, is_csv = false) => {
        props.onAdhocHistoryReport(page, limit, sort, order, class_id, class_name, dormitory_id, dormitory_name, gender, to_date, from_date, search, fromTime, toTime, is_pdf, is_csv).then((response) => {
            if (response.success === true) {
                let adhoc_leave_history_report = response.data;
                console.log("adhoc_leave_history_report", adhoc_leave_history_report);
                adhoc_leave_history_report.forEach(element => {
                    let daysArray = []
                    element.adhoc_leave_details.forEach((data_obj) => {
                        daysArray.push(data_obj.adhoc_leave_day)
                    })
                    const uniqueSet = new Set( daysArray);
                    const uniqueArray = [...uniqueSet];
                    element.adhoc_days = uniqueArray
                    console.log("adhoc_leave_history_report",uniqueArray);
                });
                setAdhocHistoryReport(adhoc_leave_history_report)
                setCount(response.totalCount)
                setPdf_url(response.file)
                setIsCsv(response.csvFile)
                // setPdf_url(response.file)
                // setIsCsv(response.csvFile)
            } else {
            }
        });
    }



    const handleChange = (event, value) => {
        setPage(value);
    };

    const changeLimit = (e) => {
        setPage(1);
setLimit(parseInt(e.value));
    };

    const DownloadPdf = () => {
        AdhocHistoryReport(true, false);
        console.log("pdf_url", pdf_url);
        const link = document.createElement("a");
        link.href = pdf_url;
        link.target = "_blank"
        // link.setAttribute("download");
        document.body.appendChild(link);
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }
    const DownloadCsvFile = () => {
        AdhocHistoryReport(false, true);
        const link = document.createElement("a");
        link.href = isCsv;
        // link.target = "_blank"
        // link.setAttribute("download");
        document.body.appendChild(link);
        link.click();
        // Clean up and remove the link
        link.parentNode.removeChild(link);
    }



    useEffect(() => {
        GetAllClassesList();
        GetAllDormitoryStudent();
    }, []);

    const GetAllClassesList = async () => {
        props.onGetAllClassesList().then((response) => {
            if (response.success === true) {
                const arrayData = response.data.rows;
                let state_data = [];
                state_data.push({
                    label: "Select Year",
                    value: "",
                })
                for (let key in arrayData) {
                    state_data.push({
                        label: arrayData[key].class_name,
                        value: arrayData[key].class_id,
                        class_name: arrayData[key].class_name
                    })
                }
                setclass_ids(state_data);
            }
        });
    };

    const GetAllDormitoryStudent = async () => {
        props.onGetAllDormitoryStudent(true).then((response) => {
            if (response.success === true) {
                let state_data = [];
                state_data.push({
                    label: "Select Dormitory",
                    value: "",
                });
                const arrayData = response.data.rows;
                for (let key in arrayData) {
                    state_data.push({
                        label: arrayData[key].dormitory_name,
                        value: arrayData[key].dormitory_id,
                        dormitory_name: arrayData[key].dormitory_name
                    });
                }
                setdormitory_ids(state_data);
            } else {
                //notify.show(response.message, "error");
            }
        });
    };


    // Scroll bar To top functionality
        const [scrollWidth, setScrollWidth] = useState(0);
        const topScrollbarRef = useRef(null);
        const tableContainerRef = useRef(null);
        const scrollbarContentRef = useRef(null);
        useEffect(() => {
            // 
            const topScrollbar = topScrollbarRef.current;
            const tableContainer = tableContainerRef?.current;
            const scrollbarContent = scrollbarContentRef.current;
    
            if (adhocHistoryReport.length > 0) {
                // setScrollWidth(tableContainerRef.current.querySelector(".table").scrollWidth);
                // Set the width of the scrollbar content based on the table container width
                if (scrollbarContent && tableContainer) {
                    scrollbarContent.style.width = `${tableContainerRef.current.querySelector(".table").scrollWidth}px`;
                }
    
                // Sync scroll positions between topScrollbar and tableContainer
                const handleTopScrollbarScroll = () => {
                    tableContainer.scrollLeft = topScrollbar.scrollLeft;
                };
    
                const handleTableContainerScroll = () => {
                    topScrollbar.scrollLeft = tableContainer.scrollLeft;
                };
    
                if (topScrollbar && tableContainer) {
                    topScrollbar.addEventListener('scroll', handleTopScrollbarScroll);
                    tableContainer.addEventListener('scroll', handleTableContainerScroll);
                }
    
                // Cleanup event listeners on unmount
                return () => {
                    if (topScrollbar && tableContainer) {
                        topScrollbar.removeEventListener('scroll', handleTopScrollbarScroll);
                        tableContainer.removeEventListener('scroll', handleTableContainerScroll);
                    }
                };
            }
    
    
        }, [adhocHistoryReport]);
        console.log("scrollWidth::", scrollWidth)

    return (
        <>
            <div id="kt_body" className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-fixed" >
                <div className="d-flex flex-column flex-root">
                    <div className="page d-flex flex-row flex-column-fluid">
                        <SideBarLeave />
                        <div className="wrapper d-flex flex-column flex-row-fluid " id="kt_wrapper">
                            <TopBar />
                            <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                                <div className="post d-flex flex-column-fluid" id="kt_post">
                                    {/* <!--begin::Container--> */}
                                    <div id="kt_content_container" className="container-fluid">
                                    {showFilters && (
                                        <div className='row'>
                                            <div className='col-md-12'>
                                                <div className='card'>
                                                    <div className='card-header align-items-center'>
                                                        <h3 className='card-title'>Student Search</h3>
                                                    </div>
                                                    <div className='card-body'>
                                                        <div className='row'>
                                                            <div className='col-12'>
                                                                <div className='row gap-y-3'>
                                                                    <div className='col-lg-3 col-md-6'>
                                                                        <label className="fw-bold mb-3">Select Year</label>
                                                                        {console.log("customStyles", class_ids)}
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={class_ids}
                                                                            value={class_ids.find((option) => {
                                                                                return option.value === class_id;
                                                                            })}
                                                                            onChange={(event) => {
                                                                                setclass_id(event.value); setclass_name(event.class_name)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-6">
                                                                        <label className="fw-bold mb-3">Select Dormitory</label>
                                                                        <Select
                                                                            styles={customStyles}
                                                                            className="react-bootstrap-typeahead tag-outer"
                                                                            options={dormitory_ids}
                                                                            value={dormitory_ids.find((option) => {
                                                                                return option.value === dormitory_id;
                                                                            })}
                                                                            onChange={(event) => {
                                                                                setdormitory_id(event.value); setdormitory_name(event.dormitory_name)
                                                                            }}
                                                                        />
                                                                    </div>
                                                                  

                                                                    <div className='col-lg-3 col-md-6'>
                                                                        <div className='form-group'>
                                                                            <label className="fw-bold mb-3">Student Name</label>
                                                                            <div className="position-relative">
                                                                                <span className='search-icon-block'>
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none">
                                                                                        <path d="M19 19L13.0001 13M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8Z" stroke="#999" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                                                    </svg>
                                                                                </span>
                                                                                <input
                                                                                    // id="session-date"
                                                                                    type="search"
                                                                                    className="form-control pe-10"
                                                                                    placeholder="Search..."
                                                                                    value={search}
                                                                                    onChange={(e) => setSearch(e.target.value)}
                                                                                    required
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-lg-3 col-md-6'>
                                                                        <label className="fw-bold mb-3">Gender</label>
                                                                        <div className="d-flex mt-2 radio-btn">
                                                                            <label className="cursor-pointer d-flex align-items-center">
                                                                                <input
                                                                                    type="radio"
                                                                                    id="gende"
                                                                                    name="gen"
                                                                                    className="form-check-input me-2 cursor-pointer"
                                                                                    value="male"
                                                                                    onChange={(event) => { setGender(event.target.value); }}
                                                                                    checked={gender === "male" ? true : false}
                                                                                />
                                                                                Male
                                                                            </label>
                                                                            <label className="cursor-pointer d-flex align-items-center">
                                                                                <input
                                                                                    type="radio"
                                                                                    id="gender"
                                                                                    name="gen"
                                                                                    className="form-check-input me-2 cursor-pointer"
                                                                                    value="female"
                                                                                    onChange={(event) => { setGender(event.target.value); }}
                                                                                    checked={gender === "female" ? true : false}
                                                                                />
                                                                                Female
                                                                            </label>

                                                                            <label className="cursor-pointer d-flex align-items-center">
                                                                                <input
                                                                                    type="radio"
                                                                                    id="gender"
                                                                                    name="gen"
                                                                                    className="form-check-input me-2 cursor-pointer"
                                                                                    value=""
                                                                                    onChange={(event) => { setGender(event.target.value); }}
                                                                                    checked={gender === "" ? true : false}
                                                                                />
                                                                                Both
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-6">
                                                                        <label className="me-3 form-label">From Date</label>
                                                                        <div className='position-relative'>
                                                                            <span className='position-absolute apply_adhoc_leave_date_and_time'>
                                                                                <i class="far fa-calendar-alt"></i>
                                                                            </span>
                                                                            <input
                                                                                id="session-date"
                                                                                type="date"
                                                                                className="form-control bg-transparent"
                                                                                // placeholder='Date From'
                                                                                value={from_date}
                                                                                onChange={(e) => setFromDate(e.target.value)}
                                                                                required
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-3 col-md-6">
                                                                        <label className="me-3 form-label">To Date</label>
                                                                        <div className='position-relative'>
                                                                            <span className='position-absolute apply_adhoc_leave_date_and_time'>
                                                                                <i class="far fa-calendar-alt"></i>
                                                                            </span>
                                                                            <input
                                                                                id="session-date"
                                                                                type="date"
                                                                                className="form-control bg-transparent"
                                                                                // placeholder='Date To'
                                                                                value={to_date}
                                                                                onChange={(e) => setToDate(e.target.value)}
                                                                                required
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-3 col-md-6">
                                                                        <label className="ms-3 me-3 form-label">Time From</label>
                                                                        <div className='position-relative'>
                                                                            <span className='position-absolute apply_adhoc_leave_date_and_time'>
                                                                                <i class="far fa-calendar-alt"></i>
                                                                            </span>
                                                                            <input
                                                                                id="session-date"
                                                                                type="time"
                                                                                className="form-control bg-transparent"
                                                                                placeholder='Time From'
                                                                                value={fromTime}
                                                                                onChange={(e) => setFromTime(e.target.value)}
                                                                                min={from_date}
                                                                                required
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-lg-3 col-md-6">
                                                                        <label className="ms-3 me-3 form-label">Time to</label>
                                                                        <div className='position-relative'>
                                                                            <span className='position-absolute apply_adhoc_leave_date_and_time'>
                                                                                <i class="far fa-calendar-alt"></i>
                                                                            </span>
                                                                            <input
                                                                                id="session-date"
                                                                                type="time"
                                                                                className="form-control bg-transparent"
                                                                                placeholder='Time To'
                                                                                value={toTime}
                                                                                onChange={(e) => setToTime(e.target.value)}
                                                                                required
                                                                            />
                                                                        </div>
                                                                    </div>

                                                                    <div className='col-lg-3 col-md-6'>
                                                                        <div >
                                                                            <button type="reset" className="btn btn-secondary btn-sm  "
                                                                                onClick={(event) => {
                                                                                    setclass_id("");
                                                                                    setdormitory_id("");
                                                                                    setclass_name("");
                                                                                    setdormitory_name("");
                                                                                    setSearch("");
                                                                                    setGender("");
                                                                                    setFromDate("")
                                                                                    setToDate("")
                                                                                    setFromTime("")
                                                                                    setToTime("")
                                                                                }} >Clear Search
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                         
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>)}
                                        <div className="row mt-5">
                                            <div className="col-sm-12">
                                                <div className="card  tabs-outer">
                                                    <div className="card-header">
                                                        <h2 className="card-title">Adhoc Leave History Report</h2>
                                                        <div className="d-flex align-items-center">
                                                            <Tooltip title="Download .pdf" placement="top">
                                                                <IconButton onClick={() => DownloadPdf()}>
                                                                    <i class="fas fa-file-pdf"></i>
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Download .csv" placement="top">
                                                                <IconButton onClick={() => DownloadCsvFile()}>
                                                                    <i class="fas fa-file-csv"></i>
                                                                </IconButton>
                                                            </Tooltip>
                                                            <button
                                                type="button"
                                                className="btn btn-primary btn-lg fw-bolder "
                                                onClick={toggleFilters}
                                                style={{ minWidth: '150px' }}
                                             >
                                                {showFilters ? 'Hide Filters' : 'Show Filters'}
                                                <i className={`fas ${showFilters ? 'fa-chevron-up' : 'fa-filter'} ms-2`}></i>
                                             </button>
                                                        </div>
                                                    </div>
                                                    <div className="card-body">
                                                    <div
                                                    className="scrollbar-container"
                                                    ref={topScrollbarRef}
                                                    style={{
                                                        overflowX: 'auto',
                                                        height: '20px',
                                                        marginBottom: '10px',
                                                        // backgroundColor: '#f8f9fa',
                                                    }}
                                                >
                                                    <div ref={scrollbarContentRef} className="scrollbar-content" style={{ width: '100%', height: '1px' }} />
                                                </div>
                                                        <div className="card-toolbar">
                                                            <div ref={tableContainerRef} className="table-responsive">
                                                            <MDBTable className='table-row-bordered'>
                                                                <MDBTableHead>
                                                                    <tr>
                                                                        <th>S.No.</th>
                                                                        <th>Student Name</th>
                                                                        <th>Year</th>
                                                                        <th>Dormitory</th>
                                                                        <th>Activity</th>
                                                                        <th>Venue</th>
                                                                        <th>Days</th>
                                                                        <th>Start Date</th>
                                                                        <th>End Date</th>
                                                                        <th>Start Time</th>
                                                                        <th>Finish Time</th>
                                                                        <th>Travel Out</th>
                                                                        <th>Travel In</th>
                                                                    </tr>
                                                                </MDBTableHead>
                                                                <MDBTableBody>
                                                                    {console.log("adhocHistoryReport", adhocHistoryReport)}
                                                                    {adhocHistoryReport.map((report, index) => {
                                                                        return (
                                                                            <tr>
                                                                                <td>{index + 1}</td>
                                                                                <td>{report.adhoc_stu_data[0].student_name}</td>
                                                                                <td>{report.adhoc_stu_data[0].stu_class_data.class_name}</td>
                                                                                <td>{report.adhoc_stu_data[0].dormitory_data.dormitory_name}</td>
                                                                                <td>{report.adhoc_activity_data.activity_name}</td>
                                                                                <td>{report.venue}</td>


                                                                                <td>{report.adhoc_days.join("-")}</td>
                                                                                <td>{report.start_date}</td>
                                                                                <td>{report.end_date}</td>
                                                                                <td>{moment(report.start_time, 'HH:mm').format('hh:mm A')}</td>
                                                                                <td>{moment(report.end_time, 'HH:mm').format('hh:mm A')}</td>
                                                                                <td>{report.depart_mode_data.travel_mode_name}</td>
                                                                                <td>{report.arrival_mode_data.travel_mode_name}</td>



                                                                            </tr>
                                                                        )
                                                                    })}


                                                                </MDBTableBody>
                                                            </MDBTable>
                                                            </div>
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <Select
                                                                menuPlacement="top"
                                                                className="basic-single"
                                                                classNamePrefix="select"
                                                                defaultValue={row_limit[1]}
                                                                name="color"
                                                                options={row_limit}
                                                                onChange={changeLimit}
                                                            />
                                                            <Stack spacing={1} >
                                                                <Pagination
                                                                    count={Math.ceil(count / limit)}
                                                                    page={page}
                                                                    onChange={handleChange}
                                                                    color="primary"
                                                                />
                                                            </Stack>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


function mapStateToProps(state) {
    return {
        // error: state.students.error,
        // loader: state.students.loader,
        // isAuthenticated: state.students.isAuthenticated,
    };
}

const mapDispatchToProps = {
    onGetAllDormitoryStudent: userActions.GetAllDormitoryStudent,
    onGetAllClassesList: userActions.GetAllClassesList,
    onAdhocHistoryReport: userActions.AdhocHistoryReport,
};
export default connect(mapStateToProps, mapDispatchToProps)(AdhocLeaveHistoryReport);